
import Loading from 'vux/src/components/loading/index.vue'

import { mapState } from 'vuex'
const metaData = [
{
name: 'viewport', content: 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0'
},
{
name: 'apple-mobile-web-app-capable', // <!-- 删除苹果默认的工具栏和菜单栏 -->
content: 'yes'
},
{
name: 'apple-mobile-web-app-status-bar-style', // <!-- 设置苹果工具栏颜色 -->
content: 'black'
},
{
name: 'format-detection', // <!--忽略页面中的数字识别为电话，忽略email识别 -->
content: 'telephone=no, email=no'
},
{
name: 'renderer', content: 'webkit' // <!-- 启用360浏览器的极速模式(webkit) -->
},
{
name: 'X-UA-Compatible', content: 'IE=edge' // <!-- 避免IE使用兼容模式 -->
},
{
name: 'HandheldFriendly', content: 'true' // <!-- 针对手持设备优化，主要是针对一些老的不识别viewport的浏览器，比如黑莓 -->
},
{
name: 'MobileOptimized', content: '320' // <!-- 微软的老式浏览器 -->
},
{
name: 'screen-orientation', content: 'portrait' // <!-- uc强制竖屏 -->
},
{
name: 'x5-orientation', content: 'portrait' // <!-- QQ强制竖屏 -->
},
{
name: 'full-screen', content: 'yes' // <!-- UC强制全屏 -->
},
{
name: 'x5-fullscreen', content: 'true' // <!-- QQ强制全屏 -->
},
{
name: 'browsermode', content: 'application' // <!-- UC应用模式 -->
},
{
name: 'x5-page-mode', content: 'app' // <!-- QQ应用模式 -->
},
{
name: 'msapplication-tap-highlight', content: 'no' // <!-- windows phone 点击无高光 -->
}
]
export default {
name: 'App',
metaInfo () {
return {
title: this.pageTitle,
meta: metaData





}
},
components: {
Loading
},
computed: {
...mapState({
isLoading: state => state.vux.isLoading,
suspensionbox: state => state.vux.suspension
})
},
watch: {
'$route' (to, from) {
if (to.path === '/home') {
this.pageTitle = sessionStorage.getItem('store_name') ? sessionStorage.getItem('store_name') : '商城'
} else {
this.pageTitle = to.meta.title
}

}
},
data () {
return {
pageTitle: '商城',
metaData: [
]
}
},
mounted () {
if (!this.suspensionbox) {
let suspensionbox = setInterval(() => {
if (this.$route.query.store_id) {

if (document.hidden) {
window.location.href = window.location.protocol + '//' + window.location.host + '/?store_id=' + this.$route.query.store_id
clearInterval(this.suspensionbox)
this.$store.commit('updateSuspensionbox', { count: undefined })
}







}
}, 60000)
this.$store.commit('updateSuspensionbox', { count: suspensionbox })
}
this.pageTitle = sessionStorage.getItem('store_name') ? sessionStorage.getItem('store_name') : '商城'









}
}



// WEBPACK FOOTER //
// ./src/App.vue